import { FetchStatus } from '../core';
import { RootState } from '../index';
import { SpaceTab } from './schema';

export const getIsCreating = ({ spaceTabs }: RootState): boolean =>
  spaceTabs.creating;

export const getIsEmbedding = ({ spaceTabs }: RootState): boolean =>
  spaceTabs.embedding;

export const getSpaceTabsBySpaceId =
  (spaceId: number) =>
  ({ spaceTabs }: RootState): SpaceTab[] =>
    Object.values(spaceTabs.items).filter((s) => Number(s.space) === spaceId);

export const getSpaceTabByIdSelector =
  (spaceTabId: number) =>
  ({ spaceTabs }: RootState): SpaceTab =>
    spaceTabs.items[spaceTabId];

export const getActiveTabKey = ({ spaceTabs }: RootState): string =>
  spaceTabs.activeTabKey;

export const isSpaceTabUpdatingSelector = ({ spaceTabs }: RootState): boolean =>
  spaceTabs.updating;

export const isSpaceTabDeletingSelector = ({ spaceTabs }: RootState): boolean =>
  spaceTabs.deleting;

export const selectSpaceTab =
  (spaceTabId: number) =>
  ({ spaceTabs }: RootState): SpaceTab =>
    spaceTabs.items[spaceTabId];

export const selectSpaceTabFetchStatus =
  (spaceTabId: number) =>
  ({ spaceTabs }: RootState): FetchStatus =>
    spaceTabs.itemsFetchStatus[spaceTabId];
